module.exports = __webpack_public_path__ + "img/5.c45ea5ff.jpg";